module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-03-35315d2d85feb8b3c5e4e1694b6f67bf.jpg";